module.exports = __webpack_public_path__ + "static/media/bubble-bg.17529908.png";